import WuLayoutContentWrapper from '@layout/components/WuLayoutContentWrapper';
import WuLayoutFooter from '@layout/components/WuLayoutFooter';
import WuLayoutHeader from '@layout/components/WuLayoutHeader';
import { Outlet } from 'react-router-dom';

function WuDashboardLayout() {
  return (
    <>
      <WuLayoutHeader />
      <WuLayoutContentWrapper>
        <Outlet />
      </WuLayoutContentWrapper>
      <WuLayoutFooter />
    </>
  );
}

export default WuDashboardLayout;
